var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorfulJpgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "folder icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    filter: "url(#filter0_ii_10_74730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4375 4.58301C11.2284 4.58301 9.4375 6.37387 9.4375 8.583V46.4163C9.4375 48.6255 11.2284 50.4163 13.4375 50.4163H42.5625C44.7716 50.4163 46.5625 48.6255 46.5625 46.4163V16.0413L35.1042 4.58301L13.4375 4.58301Z",
    fill: "#F6AD00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter1_dd_10_74730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6202 37.7976L21.7965 31.6594C21.85 31.5807 21.9201 31.5147 22.0018 31.4662C22.0836 31.4176 22.1751 31.3876 22.2698 31.3782C22.3644 31.3689 22.46 31.3805 22.5497 31.4122C22.6394 31.4439 22.721 31.495 22.7888 31.5617L25.5488 34.2659L31.6045 24.7741C31.6645 24.6799 31.7477 24.6027 31.8462 24.5501C31.9447 24.4975 32.0551 24.4711 32.1667 24.4736C32.2783 24.4761 32.3874 24.5074 32.4835 24.5644C32.5795 24.6214 32.6592 24.7022 32.7148 24.799L40.239 37.8386C40.2961 37.9373 40.3262 38.0493 40.3263 38.1634C40.3263 38.2775 40.2963 38.3895 40.2393 38.4883C40.1822 38.5871 40.1002 38.6691 40.0013 38.7261C39.9025 38.783 39.7904 38.813 39.6764 38.8128H18.1573C18.0391 38.8131 17.9231 38.781 17.8217 38.7201C17.7204 38.6593 17.6376 38.5719 17.5823 38.4674C17.5269 38.3629 17.5012 38.2453 17.5079 38.1272C17.5145 38.0092 17.5532 37.8952 17.6199 37.7976H17.6202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8709 23.8989C18.8709 24.7672 19.2158 25.6 19.8298 26.214C20.4438 26.8279 21.2765 27.1729 22.1448 27.1729C23.0131 27.1729 23.8459 26.8279 24.4598 26.214C25.0738 25.6 25.4188 24.7672 25.4188 23.8989C25.4188 23.0306 25.0738 22.1979 24.4598 21.5839C23.8459 20.9699 23.0131 20.625 22.1448 20.625C21.2765 20.625 20.4438 20.9699 19.8298 21.5839C19.2158 22.1979 18.8709 23.0306 18.8709 23.8989Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M45.4873 14.9678L36.1782 14.9678L46.5623 25.3519L46.5623 16.042L45.4873 14.9678Z",
    fill: "url(#paint0_linear_10_74730)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M46.5625 16.042L35.1042 4.58366C35.1042 10.9119 40.2342 16.042 46.5625 16.042Z",
    fill: "#FBDE99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_10_74730",
    x: 9.4375,
    y: 3.58301,
    width: 37.125,
    height: 47.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10_74730"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_10_74730",
    result: "effect2_innerShadow_10_74730"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_10_74730",
    x: 16.5068,
    y: 19.625,
    width: 31.8193,
    height: 29.1875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_74730"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_10_74730",
    result: "effect2_dropShadow_10_74730"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_10_74730",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_74730",
    x1: 38.5057,
    y1: 12.6403,
    x2: 48.8898,
    y2: 23.0244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulJpgIcon);
export default __webpack_public_path__ + "static/media/colorful-jpg-icon.a8f48f1bcd25a5b26135294a5e1ee94b.svg";
export { ForwardRef as ReactComponent };